import * as R from 'ramda'
import { call, reducer } from '../../helpers/api/meta'
import { getLearnerCourseDetail } from '../../helpers/api/api'

export const GET_LEARNER_COURSE_DETAIL = 'GET_LEARNER_COURSE_DETAIL'

export const callGetLearnerCourseDetail = (inputs) => {
  const meta = {
    endpoint: (params) => getLearnerCourseDetail(params),
    inputs,
    action: GET_LEARNER_COURSE_DETAIL,
    messages: {
      id: 'getLearnerCourseDetail',
      failure: 'Could not get course detail',
    },
  }
  return call(meta)
}

const initialState = {
  loading: false,
  learnerCourseDetail: {},
}

const saveLearnerCourseDetail = (state, action) => {
  if (action && action.results) {
    const results = { ...action.results }
    return R.assoc('learnerCourseDetail', results, state)
  } else {
    return R.assoc('learnerCourseDetail', action, state)
  }
}

const messages = {
  loadFailed: 'Could not load courses.',
}

export default reducer(initialState, GET_LEARNER_COURSE_DETAIL, saveLearnerCourseDetail, messages.loadFailed)
